export function createNoParamLink(apiPathElement: string) {
    return () => apiPathElement;
}
export function createNoParamLink(apiPathElement: string) {
    return () => apiPathElement;
}
